import {
  SET_BASEPATH,
  SET_CATALOG_LIST,
  SET_DATA,
  SET_ERROR,
  SET_FORM_VALUES,
  SET_INITIALISED,
  SET_LOADED_CONFIGURATION,
  SET_PARTS_LIST,
  SET_HIGHLIGHTED_PART,
  SET_BIKE,
  SET_STEP,
  SET_PARTS_MODAL_PAGE,
  SET_DELIVERY_METHOD,
  SET_SELECTED_DEALER,
  SET_GEOLOCATION,
  SET_BASKET_ITEMS,
  SET_BASKET_SUMMARY,
} from './types';

export const setInitialised = () => ({
  type: SET_INITIALISED,
});

export const setData = (payload) => ({
  type: SET_DATA,
  payload,
});

export const setBasepath = (payload) => ({
  type: SET_BASEPATH,
  payload,
});

export const setError = (payload) => ({
  type: SET_ERROR,
  payload,
});

export const setBasketItems = (payload) => ({
  type: SET_BASKET_ITEMS,
  payload,
});

export const setBasketSumary = (payload) => ({
  type: SET_BASKET_SUMMARY,
  payload,
});

export const setCatalogList = (payload) => ({
  type: SET_CATALOG_LIST,
  payload,
});

export const setPartsModalPage = (payload) => ({
  type: SET_PARTS_MODAL_PAGE,
  payload,
});

export const setPartsList = (payload) => ({
  type: SET_PARTS_LIST,
  payload,
});

export const setHighlightedPart = (payload) => ({
  type: SET_HIGHLIGHTED_PART,
  payload,
});

export const setBike = (payload) => ({
  type: SET_BIKE,
  payload,
});

export const setDeliveryMethod = (payload) => ({
  type: SET_DELIVERY_METHOD,
  payload,
});

export const setGeolocation = (payload) => ({
  type: SET_GEOLOCATION,
  payload,
});

export const setSelectedDealer = (payload) => ({
  type: SET_SELECTED_DEALER,
  payload,
});

export const setStep = (payload) => ({
  type: SET_STEP,
  payload,
});

export const setFormValues = (payload) => ({
  type: SET_FORM_VALUES,
  payload,
});

export const setLoadedConfiguration = (payload) => ({
  type: SET_LOADED_CONFIGURATION,
  payload,
});
